import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage, Field } from 'formik'

import { getFieldState } from 'services/Forms'
import { Button as MerinioButton } from 'ui'

import { t } from 'translations'

const Checkbox = ({ customLabelElement, customIconElement, fieldClass, inputGroup, label, noDescription, inputOnly, text, buttonCheckbox, ...props }) => (
  // Add the required * if the input is mandatory

  <Field {...props}>
    {({ field, form }) => {
      const fieldState = getFieldState(form, field)

      // Returns the checkbox as a button
      if (buttonCheckbox) {
        return (
          <MerinioButton
            color="secondary"
            outlined={!field.value}
            disabled={props.disabled}
            onClick={e => {
              e.preventDefault()
              form.setFieldValue(props.name, !field.value)
            }}
          >
            {t(text.label || label || `${props.module}.${(props.translation || props.name).toUpperCase()}.LABEL`)}
          </MerinioButton>
        )
      }

      // Returns only the input without the label or description
      if (inputOnly) {
        return (
          <input
            {...props}
            {...field}
            checked={field.value}
            onChange={() => form.setFieldValue(props.name, !field.value)}
            className={`form-check-input ${fieldState}`}
          />
        )
      }
      return (
        <div className={`form-group form-check ${fieldState} ${props.required ? 'required' : ''} ${fieldClass}`}>
          <input
            {...props}
            {...field}
            checked={field.value}
            onChange={() => form.setFieldValue(props.name, !field.value)}
            className={`form-check-input ${fieldState}`}
          />
          <label className="form-check-label" onClick={() => form.setFieldValue(props.name, !field.value)}>
            {t(text.label || label || `${props.module}.${(props.translation || props.name).toUpperCase()}.LABEL`)}
            {customLabelElement} {customIconElement}
          </label>
          {noDescription ? null : (
            <small className="form-text text-muted">
              {text.description || t(`${props.module}.${(props.translation || props.name).toUpperCase()}.DESCRIPTION`)}
            </small>
          )}
          <ErrorMessage name={props.name} render={msg => <span className="text-danger"> {t(msg)}</span>} />
        </div>
      )
    }}
  </Field>
)

export default Checkbox

// Set the proptypes for validation
Checkbox.propTypes = {
  autoComplete: PropTypes.string,
  module: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fieldClass: PropTypes.string,
  translation: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validation: PropTypes.func,
  required: PropTypes.bool,
  text: PropTypes.object,
  customLabelElement: PropTypes.element,
  customIconElement: PropTypes.element
}
Checkbox.defaultProps = {
  fieldClass: '',
  type: 'checkbox',
  required: false,
  text: {}
}
